import src from "IMAGE";
export default { src, width: 1360, height: 323, blurWidth: 0, blurHeight: 0};
